import httpUtil from "@/utils/httpUtil";
import config from "@/config"

/** 获取证书类型 */
export function type_list(params,type) {
    return httpUtil.get(`${config.API_URL}/index/type_list`, params, type)
}
/** 查询个人证书*/
export function userCertificate(params,type) {
    return httpUtil.get(`${config.API_URL}/index/user1`, params, type)
}

/** 查询企业证书 */
export function companyCertificate(params,type) {
    return httpUtil.get(`${config.API_URL}/index/user2`, params, type)
}
/** 查询证书说明 */
export function configinfo(params,type) {
    return httpUtil.get(`${config.API_URL}/index/config`, params, type)
}











